module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_f_piebald.0ee52cd1.png";